import React from "react";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "../../../components/SanitizedGrid";
import SubcontractorTimesheetAdhocFeeTable from "./SubcontractorTimesheetAdhocFeeTable";
import { FunctionField } from "react-admin";
import Alert from "@material-ui/lab/Alert";

const SubcontractorTimesheetsPanel = () => {
  return (
    <SanitizedGrid container style={{ padding: "10px 10px 25px 45px" }}>
      <Grid item xs={12}>
        <Typography variant="subtitle2">Subcontractor Adhoc Fees</Typography>
      </Grid>

      <Grid item xs={12}>
        <FunctionField
          addLabel={false}
          render={(record: any) => {
            const combinedSubcontractorAdhocFees = [];

            if (record.oldSubcontractorAdhocFee) {
              combinedSubcontractorAdhocFees.push({
                ...record.oldSubcontractorAdhocFee,
                type: "old",
              });
            }

            if (record.newSubcontractorAdhocFee) {
              combinedSubcontractorAdhocFees.push({
                ...record.newSubcontractorAdhocFee,
                type: "new",
              });
            }

            if (combinedSubcontractorAdhocFees?.length === 0) {
              return (
                <Alert severity="info" style={{ marginTop: "15px" }}>
                  <Typography variant="body2">
                    <strong>No Subcontractor Adhoc Fees found.</strong>
                    <br/>
                    {/* Only show more information message if there is a subcontractor assigned */}
                    {record.subcontractorId ? "This timesheet uses the originally assigned subcontractor." : ""}
                  </Typography>
                </Alert>
              )
            }

            return (
              <SubcontractorTimesheetAdhocFeeTable
                data={combinedSubcontractorAdhocFees}
              />
            )
          }}
        />
      </Grid>
    </SanitizedGrid>
  )
}

export default SubcontractorTimesheetsPanel;